import React from "react";

import { FaUserEdit } from "react-icons/fa";
import ScrollableWrapper from "components/shared/ScollableWrapper";
import { BodySVGs, HairSVGs, ClothesSVGs } from "./iserbaAvatarIconsMap";

const IserbaValidationStep = ({
	player,
	onChangePlayer,
	onEditAvatar,
	onValidatePlayer,
}) => {
	const avatar = player.avatar;
	const svgHeight = 200;

	return (
		<div className="flex flex-col items-center w-full h-full min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] overflow-hidden relative">
			<ScrollableWrapper direction="vertical" className="flex-1">
				<div className="p-6 flex flex-col items-center w-full h-full">
					<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
						Est-ce bien vous ?
					</h1>
					{/* Avatar Renderer */}
					<div className="h-[200px] relative bg-blue-200 shadow-lg rounded-2xl flex items-center justify-center w-full max-w-[200px]">
						<button
							className="absolute top-2 right-2  flex items-center gap-2 text-gray-600 text-sm font-bold"
							onClick={onEditAvatar}
						>
							<FaUserEdit /> Editer
						</button>
						<svg height={svgHeight} viewBox="0 0 200 400">
							{BodySVGs[avatar.gender](avatar.skin_color)}
							{HairSVGs[avatar.gender][avatar.hair_shape](avatar.hair_color)}
							{ClothesSVGs[avatar.gender][avatar.clothes]()}
						</svg>
					</div>

					<div className="mt-4 font-bold text-md w-full flex items-center justify-center bg-gray-100 rounded-full p-2">
						{player?.pseudo}
					</div>

					<div className="flex flex-col gap-2 items-center mt-8">
						<button
							onClick={onValidatePlayer}
							className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
						>
							Oui
						</button>
						<button
							onClick={onChangePlayer}
							className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#adadad] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#9d9d9d] disabled:bg-slate-300"
						>
							Changer de profil
						</button>
					</div>
				</div>
			</ScrollableWrapper>
		</div>
	);
};

export default IserbaValidationStep;
